<template>
    <div>
        <header>
            <div class="header">
                <div class="container">
                    <div class="row">
                        <div class="col-12 col-md-4 col-xl-6 my-2 my-sm-0 d-flex align-items-center">
                            <router-link :to="{name:'HomeLogado'}">
                                <img :src="logoBranca" />
                            </router-link>
                        </div>
                        <div class="col-12 col-md-8 col-xl-6 mt-3 mt-sm-0 d-flex justify-content-end">
                            <div class="d-flex" style=" position: relative; width: 100%; height: 100%; min-height: 65px; display: flex; justify-content: end; align-items: center;">
                                <div :class="'box-dados-usuario ' + (flDadosUsuario ?'active':'' )">
                                    <div class="box-dados-usuario-titulo" @click="flDadosUsuario = !flDadosUsuario">
                                        <template v-if="user.usuario">
                                            <!--<img :src="user.usuario.urlImgFoto" v-if="user.usuario.urlImgFoto != null" />
                                            <ImgDefault :nome="user.usuario.nmUsuario" :size="1" :borda="true" v-else></ImgDefault>-->
                                            <ImgDefault :nome="user.usuario.nmUsuario" :size="1" :borda="true"></ImgDefault>
                                        </template>

                                        <span class="ms-3 txt-p txt-size-20" v-if="user.usuario != null">Olá, <b>{{primeiroNome}}</b></span>
                                        <span class="ms-3 txt-p c-pointer txt-size-20" data-bs-toggle="dropdown" aria-expanded="false"><i class="fas fa-caret-down"></i></span>
                                    </div>


                                    <div class="box-dados-usuario-conteudo">
                                        <p class="txt-p txt-roxo-1 txt-w-5 c-pointer mb-1" @click="showModalDados = !showModalDados"><i class="fas fa-user me-2"></i> Meus dados</p>
                                        <p class="txt-p txt-roxo-1 txt-w-5 c-pointer mb-1" @click="showModalSenha = !showModalSenha"><i class="fas fa-key me-2"></i> Mudar senha</p>
                                        <p v-if="isAdmin" class="txt-p txt-roxo-1 txt-w-5 c-pointer mb-1" @click="gerenciarUsuarios"><i class="fas fa-users me-2"></i> Gerenciar Usuários</p>
                                        <!-- SUPORTE -->
                                        <template v-if="user.usuario.tpPessoa == 'J' && user.usuario.flCortesia != 'Sim'">
                                            <a  class="txt-p txt-roxo-1 txt-w-5 c-pointer mb-1" v-if="user.usuario.idContrato != null && user.usuario.idPessoa != null"
                                               :href="urlSuporte+'p_idContrato='+user.usuario.idContrato+'&amp;p_idPessoa='+user.usuario.idPessoa" target="_blank">
                                                <i class="fas fa-headset me-2"></i>
                                                <span>Falar com o suporte</span>
                                            </a>
                                        </template>
                                        <p class="txt-p txt-roxo-1 txt-w-5 c-pointer mb-2" @click="sair"><i class="fas fa-sign-out-alt me-2"></i> Sair</p>
                                    </div>

                                </div>
                            </div>

                            
                        </div>
                    </div>

                </div>
            </div>
            <div class="menu">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="d-flex justify-content-center align-items-center w-100">
                            <span class="txt-h-4 txt-white px-3 position-relative c-pointer" @click="acessarModulo(item)" target="_blank" v-for="(item,index) in links" :key="index">
                                {{item.text}}
                                <span class="icon-badge"><i class="fas fa-external-link-alt"></i></span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

        </header>

        <MudarSenha :showModal="showModalSenha"></MudarSenha>
        <MeusDados :showModal="showModalDados"></MeusDados>
    </div>
</template>

<script>
    import logoBranca from '@/assets/img/logo-branca.png'
    import { urlApi, avisoErro, urlFerramentas, urlMural, urlPortal, urlSuporte } from '@/config/global'
    import axios from 'axios'

    import MudarSenha from '@/components/MudarSenha'
    import MeusDados from '@/components/MeusDados'
    import ImgDefault from '@/components/ImgDefault'

    export default {
        name: 'Header',
        components: { MudarSenha, MeusDados, ImgDefault },
        data: function () {
            return {
                logoBranca,
                routes: this.$router.options.routes.filter(x => x.meta != undefined && x.meta.authenticated == true),
                menu: [
                    { path: '/HomeLogado', name: 'HomeLogado', nickName: 'Orientações' }
                ],

                flDadosUsuario: false,
                showModalSenha: false,
                showModalDados: false,

                links: [
                    { urlModulo: urlFerramentas, text: 'MÓDULOS E FERRAMENTAS' },
                    { urlModulo: urlMural, text: 'MURAL' },
                    { urlModulo: urlPortal, text: 'PORTAL SOLLICITA' },
                ],
                urlSuporte: urlSuporte,
            }
        },
        computed: {
            user() {
                return this.$store.state.user
            },

            isAdmin() {
                return this.$store.state.isAdmContrato
            },

            inicialNome() {
                if (this.user.usuario) {
                    return this.user.usuario.nmUsuario[0];
                } else {
                    return "";
                }
            },
            primeiroNome() {
                if (this.user && this.user.usuario) {
                    if (this.user.usuario.nmUsuario) {
                        return this.user.usuario.nmUsuario.split(" ")[0]
                    } else {
                        return "";
                    }
                } else {
                    return "";
                }

            },
        },
        methods: {

            gerenciarUsuarios() {
                this.$router.push({ name: 'GerenciarUsuarios' });
            },

            subIsActive(input) {
                let name = this.$route.name.split('-')[0];
                return name == input.name;
            },


            sair() {
                let $this = this;
                axios.get(`${urlApi}/Auth/revoke`)
                    .then(function () {
                        $this.$store.commit('setUser', null)
                        $this.$router.push({ name: 'Home' });
                    })
                    .catch(res => {
                        if (res.response.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                    });
            },

            acessarModulo(modulo) {
                var url = modulo.urlModulo + 'AutenticacaoAutomatica?token=' + this.user.accessToken + '&refreshTokenWeb=' + this.user.refreshTokenWeb;
                window.location.href = encodeURI(url);
                //window.open(encodeURI(url), '_blank');
            },

        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    header {
    }

    .divisor {
        border-right: 1px solid #FFF;
    }

    .header {
        background: linear-gradient(98.19deg, #163142 1.55%, #281D2E 61.54%, #163142 100%);
        padding: 24px 0;
    }

    .menu {
        background: linear-gradient(0deg, rgba(17, 35, 48, 0.5), rgba(17, 35, 48, 0.5)), url(../assets/img/bg-header.svg);
        padding: 10px 0;
    }

    .circulo-usuario {
        background: #F4F4F4;
        border: 1px solid #732A90;
        box-sizing: border-box;
        border-radius: 50%;
        width: 45px;
        height: 45px;
        font-size: 20px;
        font-weight: 500;
        color: #474747;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .dropdown-menu.show {
        transform: translate(1520px, 83px) !important;
    }

    .icon-badge {
        font-size: 8px;
        position: absolute;
        margin-left: 3px;
    }

     .box-dados-usuario {
        padding: 10px;
        color: #FFF;
        z-index: 999;

        .box-dados-usuario-conteudo {
            display: none;
        }

        .box-dados-usuario-titulo {
            cursor: pointer;
            display: flex;
            align-items: center;

            img {
                width: 45px;
                height: 45px;
                border-radius: 50%;
            }
        }
    }

    .box-dados-usuario.active {
        position: absolute;
        top: 15%;
        background-color: #FFF;
        box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
        border-radius: 10px;
        color: #5B306C;

        .box-dados-usuario-conteudo {
            display: block;
            margin-top: 15px;

            p:hover {
                border-radius: 5px;
                background-color: #F1F1F1;
            }
        }
    }
</style>

